"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BANNER_NAVIGATION = void 0;
var icon_key_primary_svg_1 = __importDefault(require("../../images/icon_key_primary.svg"));
var icon_key_secondary_svg_1 = __importDefault(require("../../images/icon_key_secondary.svg"));
var icon_key_luxe_svg_1 = __importDefault(require("../../images/icon_key_luxe.svg"));
var icon_key_available_svg_1 = __importDefault(require("../../images/icon_key_available.svg"));
var icon_key_fast_svg_1 = __importDefault(require("../../images/icon_key_fast.svg"));
exports.BANNER_NAVIGATION = [
    {
        icon: icon_key_primary_svg_1.default,
        text: 'BANNER_SECTION.PRIMARY',
        page: 'sell',
        uri: {
            amd: 'is_developer=true&page=1&state=1',
            usd: 'is_developer=true&page=1&state=1',
            rub: 'is_developer=true&page=1&state=1',
        },
    },
    {
        icon: icon_key_secondary_svg_1.default,
        text: 'BANNER_SECTION.SECONDARY',
        page: 'sell',
        uri: {
            amd: 'is_developer=false&page=1&state=1',
            usd: 'is_developer=false&page=1&state=1',
            rub: 'is_developer=false&page=1&state=1',
        },
    },
    {
        icon: icon_key_luxe_svg_1.default,
        text: 'BANNER_SECTION.LUXE',
        page: 'rent',
        uri: {
            amd: "page=1&price=amd~gte_350001-lte_500000&price=amd~gte_500001-lte_750000&price=amd~gte_750001&rental_price_type=monthly_price&state=1",
            usd: "page=1&price=usd~gte_701-lte_1000&price=usd~gte_1001-lte_1500&price=usd~gte_1501&rental_price_type=monthly_price&state=1",
            rub: "page=1&price=rub~gte_70001-lte_100000&price=rub~gte_500001-lte_150000&price=rub~gte_150001&rental_price_type=monthly_price&state=1",
        },
    },
    {
        icon: icon_key_available_svg_1.default,
        text: 'BANNER_SECTION.AVAILABLE',
        page: 'sell',
        uri: {
            amd: "building_name=&page=1&price=amd~lt_20000000&price=amd~gte_20000001-lte_30000000&public_code=&state=1",
            usd: "building_name=&page=1&price=usd~lt_40000&price=usd~gte_40000-lte_60000&public_code=&state=1",
            rub: "building_name=&page=1&price=rub~lt_4000000&price=rub~gte_4000001-lte_6000000&public_code=&state=1",
        },
    },
    {
        icon: icon_key_fast_svg_1.default,
        text: 'BANNER_SECTION.FAST',
        page: 'sell',
        uri: {
            amd: 'is_favorite=yes&page=1&state=1',
            usd: 'is_favorite=yes&page=1&state=1',
            rub: 'is_favorite=yes&page=1&state=1',
        },
    },
];
